module.exports = __webpack_public_path__ + "static/media/javascript.cf53a810.svg";